import "./campaign-insights.css";
import React from "react";
import CampaignLog from "./CampaignLog";
import Page from "../../components/page/Page";
import useAppContext from "../../hooks/useAppContext";
import {getFriendlyDate} from "../../utils/friendlyDate";
import {CHART_COLORS} from "../../components/charts/consts/COLOR_SETS";
import {LineChart} from "../../components/charts/base/LineChart";
import SkeletonItem from "../../components/skeleton/SkeletonItem";

const CampaignInsights = () => {
    const { data: { lastDaysCampaigns } } = useAppContext();

    const labels = lastDaysCampaigns.data?.map((row: any) => getFriendlyDate(new Date(row.days)));
    const dataSets = [
        { label: 'Conversions', values: lastDaysCampaigns.data.map((ldm: any) => ldm.total_orders), backgroundColor: CHART_COLORS[5].solid, borderColor: CHART_COLORS[5].transparent },
        { label: 'Clicks', values: lastDaysCampaigns.data.map((ldm: any) => ldm.total_clicks), backgroundColor: CHART_COLORS[2].transparent, borderColor: CHART_COLORS[2].transparent },
        { label: 'Messages Read', values: lastDaysCampaigns.data.map((ldm: any) => ldm.total_read), backgroundColor: CHART_COLORS[1].transparent, borderColor: CHART_COLORS[1].transparent },
        { label: 'Messages Delivered', values: lastDaysCampaigns.data.map((ldm: any) => ldm.total_delivered), backgroundColor: CHART_COLORS[3].transparent, borderColor: CHART_COLORS[3].transparent },
        { label: 'Messages Sent', values: lastDaysCampaigns.data.map((ldm: any) => ldm.total_messages), backgroundColor: CHART_COLORS[0].transparent, borderColor: CHART_COLORS[0].transparent },
    ];
    const totalMessagesSent = lastDaysCampaigns.data.reduce((acc: number, row: any) => acc + parseInt(row.total_messages), 0);
    const totalConversions = lastDaysCampaigns.data.reduce((acc: number, row: any) => acc + parseInt(row.total_orders), 0);

    return <Page
        className="messages-page-container"
        title="Campaigns Insights"
        subtitle="Insights into your campaign activity, reach, and results."
    >
        <div className="messages-charts-layout">
            <div className="messages-charts-item grid-8">{lastDaysCampaigns.isLoading ? <SkeletonItem height={200} gridSpan={8} /> :
                <LineChart
                    data={lastDaysCampaigns.data}
                    labels={labels}
                    dataSets={dataSets}
                    isDataLoaded={lastDaysCampaigns.isLoaded}
                />
            }</div>
            <div className="messages-charts-item grid-4">
                {lastDaysCampaigns.isLoading ? <SkeletonItem height={200} gridSpan={4} /> :
                    <div className="weekly-summary">
                        <div className="total-sent"><div>{totalMessagesSent}</div><span>Messages Sent <span>(Campaign Messages, Last 7 Days)</span></span></div>
                        <div className="total-converted"><div>{totalConversions}</div><span>Conversions <span>(Triggered by campaign, Last 7 Days)</span></span></div>
                    </div>
                }
            </div>
        </div>
        <CampaignLog />
    </Page>
}

export default CampaignInsights;